import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
import { ViewChildren, QueryList } from '@angular/core'
import { PercentDirective } from '@ar2/common'
/**
 * 数値入力カラム
 *【内容:content:number】
 *【非活性:disabled:boolean】
 *【パーセント表示:percent:boolean】
 *【小数表示:decimalDisplay:boolean】
 *【表示桁数:displayBytes:number】
 *【小数桁数:decimalDigit:number】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-number-input-column',
  templateUrl: './number-input-column.html',
  styles: [`
    div {
      width: 100%;
    }
    mat-form-field.number-input {
      margin: 0px;
    }
    .label-percent {
      display: inline-block;
      margin: 0 0 5px 0;
    }
  `]
})
export class NumberInputColumn extends BaseWidget {
  /**
   * 項目添字
   */
  @Input() index:number

  /**
   * リスト内容
   */
  @Input() records:any[]

  /**
   * 内容の表示モデルパス
   */
  @Input() viewModelPath:string

  /**
   * 内容に対する精査エラー
   */
  @Input() errorMessages:{modelPath:string, message:string}[]

  /**
   * 非活性
   */
  @Input() disabled:boolean

  /**
   * パーセント表示
   */
  @Input() percent:boolean

  /**
   * 小数表示
   */
  @Input() decimalDisplay:boolean

  /**
   * 表示桁数
   */
  @Input() displayBytes:number

  /**
   * 小数桁数
   */
  @Input() decimalDigit:number

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
  get htmlId():string {
    return `${this.id}[${this.index}]`
  }
  /**
   * get the percentage directive
   */
  @ViewChildren(PercentDirective)
  private percentDirectives: QueryList<PercentDirective>
  /**
   * 内容
   */
  private _content: number
  @Input()
  set content(value: number) {
    if (this.content !== value) {
      this._content = value
      if (!!this.percent && this.percentDirectives && this.percentDirectives.length > 0) {
        this.percentDirectives.first.ngAfterViewInit()
      }
    }
  }
  get content(): number {
    return this._content;
  }
  /**
   * 変更前の内容
   */
  private contentBefore: number
  /**
   * 表示するcontentを設定
   */
  onFocus(event: Event) {
    this.contentBefore = this.content
    if (!this.content) {
      this._content = 0;
    }
    if (!!this.percent) {
      this.content = this.content / 100;
    }
  }
  /**
   * value設定値を更新
   */
  updateValue(event: Event, index:number) {
    if (!this.content) {
      this.content = 0;
    }
    if (!!this.percent) {
      this.content = this.content * 100;
    }
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => this.content,
      {id:this.id, type:event.type, source:event},
      `update by ${this.id}`,
    ));
    if (Number(this.contentBefore) !== Number(this.content)) {
      this.records[index]['_changed'] = true
      this.on("change", index);
    }
  }
  /**
   * このコンポーネントの状態をバインドされた表示項目の状態に反映する。
   * @param event イベント
   */
  update(event:Event) {
    const node = <HTMLFormElement>event.target
    const value = node.value
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => value,
      {id:this.id, type:event.type, source:event},
      `update by ${this.id}`,
    ))
    this.on(event)
  }
}


// WEBPACK FOOTER //
// ./src/widgets/table/number-input-column/number-input-column.component.ts